/**
 * @packageDocumentation
 * @category Component
 */

import 'BomdisoftComponents/buttons/styles.css';
import type { IconButtonSize } from 'BomdisoftComponents/buttons/render';
import { joinClasses } from 'BomdisoftComponents/html/index';
import type { ComponentProps } from 'react';

export type { IconButtonSize } from 'BomdisoftComponents/buttons/render';

export type IconButtonProps = ComponentProps<'button'> & {
  'aria-label': string;
  size?: IconButtonSize;
};

export const IconButton = ({ children, className, size = 'medium', type = 'button', ...rest }: IconButtonProps) => (
  <button className={joinClasses('bomdisoft-icon-button', className)} data-size={size} type={type} {...rest}>
    {children}
  </button>
);
